export default __webpack_public_path__ + "static/media/spider-monkey2.9179e35f.jpg";